// ═══════════════════════════════════════════════════════════════════════════
// DEVICE FINGERPRINT SERVICE
// Generates unique device ID to limit 1 account per device
// ═══════════════════════════════════════════════════════════════════════════

import FingerprintJS from '@fingerprintjs/fingerprintjs';

let cachedFingerprint = null;
let fpPromise = null;

/**
 * Get or create the device fingerprint
 * Uses FingerprintJS to generate a unique device identifier
 */
export async function getDeviceFingerprint() {
  // Return cached fingerprint if available
  if (cachedFingerprint) {
    return cachedFingerprint;
  }

  // Check localStorage for existing fingerprint
  const stored = localStorage.getItem('frankysfarm_device_id');
  if (stored) {
    cachedFingerprint = stored;
    return stored;
  }

  // Initialize FingerprintJS once
  if (!fpPromise) {
    fpPromise = FingerprintJS.load();
  }

  try {
    const fp = await fpPromise;
    const result = await fp.get();
    
    // Create a device ID combining fingerprint with some randomness
    // This ensures uniqueness even for similar devices
    const deviceId = `FP_${result.visitorId}_${Date.now().toString(36)}`;
    
    // Store for future use
    localStorage.setItem('frankysfarm_device_id', deviceId);
    cachedFingerprint = deviceId;
    
    return deviceId;
  } catch (error) {
    console.error('Fingerprint generation failed:', error);
    
    // Fallback: Generate a random ID
    const fallbackId = `FB_${Math.random().toString(36).substr(2, 9)}_${Date.now().toString(36)}`;
    localStorage.setItem('frankysfarm_device_id', fallbackId);
    cachedFingerprint = fallbackId;
    
    return fallbackId;
  }
}

/**
 * Clear the stored device fingerprint (for testing purposes)
 */
export function clearDeviceFingerprint() {
  localStorage.removeItem('frankysfarm_device_id');
  cachedFingerprint = null;
}

/**
 * Check if device fingerprint exists
 */
export function hasDeviceFingerprint() {
  return !!localStorage.getItem('frankysfarm_device_id');
}

export default {
  getDeviceFingerprint,
  clearDeviceFingerprint,
  hasDeviceFingerprint,
};
